import _defineProperty from "@babel/runtime/helpers/defineProperty";
/*
 *                     NOTICE
 *            COPYRIGHT 2022 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

export class AbInitioStaleDynamicCacheBustParametersError extends Error {
  constructor(currentRemoteDynamicCacheBustParameterValues) {
    super();
    _defineProperty(this, "_currentRemoteDynamicCacheBustParameterValues", void 0);
    this._currentRemoteDynamicCacheBustParameterValues = currentRemoteDynamicCacheBustParameterValues;
  }
  get currentRemoteDynamicCacheBustParameterValues() {
    return this._currentRemoteDynamicCacheBustParameterValues;
  }
}
//# sourceMappingURL=AbInitioStaleDynamicCacheBustParametersError.js.map
